import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import PureCounter from '@srexi/purecounterjs';

function Solutions() {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
        new PureCounter();
      }, []);

    const coreProducts = [
        {
            name: 'Control Panel',
            icon: 'bi bi-sliders2-vertical',
            desc: 'Custom-built panels for industrial control and automation.',
        },
        {
            name: 'Substation Equipment',
            icon: 'bi bi-building',
            desc: 'Reliable and robust solutions for power distribution.',
        },
        {
            name: 'Wiring Accessories',
            icon: 'bi bi-plug-fill',
            desc: 'High-quality wiring parts for safe installations.',
        },
        {
            name: 'Industrial Automation',
            icon: 'bi bi-cpu-fill',
            desc: 'Advanced systems to automate and optimize operations.',
        },
        {
            name: 'Renewable Energy',
            icon: 'bi bi-sun-fill',
            desc: 'Clean energy solutions for a sustainable future.',
        },
    ];
  return (
    <section id="about" className="about-us section py-5 mt-3">
        <div className="container py-2 mt-5" data-aos="fade-up">
            <div className="aboutus-title text-center mb-0">
            <h3 className="text-dark">Our Solutions</h3>
            <p className="text-muted">Explore the innovative solutions we provide</p>
            </div>

            <div className="row g-4 justify-content-center">
            {coreProducts.map((product, index) => (
                <div
                    key={index}
                    className="col-12 col-sm-6 col-md-4"
                    data-aos="zoom-in"
                    data-aos-delay={index * 100}
                    >
                    <div className="core-card text-center p-3 h-100 d-flex flex-column justify-content-between">
                        <div>
                        <div className="core-icon mb-3">
                            <i className={product.icon}></i>
                        </div>
                        <h6 className="fw-bold">{product.name}</h6>
                        <p className="text-muted small mb-0">{product.desc}</p>
                        </div>
                        <Link to="/contact" className="btn btn-sm btn-outline-primary mt-2">
                        Get Quote
                        </Link>
                    </div>
                </div>

            ))}
            </div>
        </div>
    </section>

  )
}

export default Solutions